<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/germany/franken')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/germany/franken/rudolf-furst')">Rudolf Furst
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/germany/franken')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Rudolf Furst</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Per i seguaci del mercato internazionale dei vini che investono, il ruolo del Pinot Nero in Germania è
                        interessante. Con l'aumento dei prezzi dei Pinot della Borgogna, gli acquirenti del secondo mercato hanno iniziato a lanciare i loro
                        reti più lontane per una qualità comparabile a un prezzo molto più basso. E la Germania offre il benvenuto
                        alternativa; qualità superba, potenziale di lungo invecchiamento e una strategia di marketing per l'esportazione che mendica
                        convinzione, alcuni produttori come Rudolf Furst, si stanno distinguendo dalla massa. COME
                        Il guru del vino Jancis Robinson ha dichiarato nel 2018: "Il Pinot Noir tedesco appartiene ora alla compagnia di grandi
                        Pinot Nero nel mondo...”.
                    </div>

                    <div class="howto-title2">Paul e Sebastian formano una grande squadra padre-figlio</div>
                    <div class="howto-text">
                        Famiglia di viticoltori da oltre 400 anni, i Furst sono nati e cresciuti nel loro
                        campi esposti a sud. Una famiglia di appassionati tradizionalisti, la tenuta è gestita da Paul e dai suoi
                        figlio Sebastian (la 2a e 3a generazione di Furst sarà al timone). I 15 ettari di ferro
                        il ricco terroir viene coltivato come è sempre stato: metodi a basso impatto, rese ridotte, meticolosità
                        gestione del baldacchino e passaggi di selezione organizzati, sottolineati da un'immensa dedizione. Questo è allora
                        seguito da un lungo, delicato, elevage in botti di rovere (tra 12-20 mesi), per risultati che sono
                        superbo e acclamato. Sia che si tratti del loro Pinot Nero (Spätburgunder) o
                        Riesling secchi, sia i rossi che i bianchi prodotti da questa tenuta sono magici.
                    </div>

                    <div class="howto-title2">Il 2014 è stato il "Vino dell'anno"</div>
                    <div class="howto-text">
                        Rudolf Furst ha fatto molta strada per dimostrare che Robert Parker si sbagliava. Parker è notoriamente citato come
                        dicendo "Il Pinot Nero tedesco è un vino grottesco e orribile che ha un sapore simile a un difettoso,
                        Borgogna rossa dolce, sbiadita, diluita da un produttore incompetente. I suoi commenti sono stati forse
                        in parte responsabile della mancanza di interesse o disponibilità dei vini Rudolf Furst negli Stati Uniti,
                        considerando che il mega-fan britannico Jancis Robinson ("Rudolf Fürst è un noto saggio del Pinot Noir in
                        Germany.") potrebbe essere uno dei motivi per cui i vini sono estremamente popolari in Gran Bretagna. Nonostante
                        le loro valutazioni costantemente elevate (in particolare da Jancis), i vini rimangono a prezzi ragionevoli; con
                        un aumento del 23% in circa cinque anni dal 2014 al 2019. Oggi aspettati di pagare circa € 100 in Europa
                        per un'annata 2014, punteggio complessivo di 92 punti e "vino rosso dell'anno" della Germania.
                    </div>

                    <div class="howto-title2">Fatti e annate notevoli</div>
                    <div class="howto-text">
                        <ul>
                            <li>Fonte di notizie statunitense Bloomberg, nel loro "Il pinot nero tedesco è l'alternativa frizzante al costoso
                                L'articolo della Borgogna" descrive i "... pinot da vigneto singoli, costosi e difficili da trovare
                                [sono] tra i migliori in Germania.”
                            </li>
                            <li>Quando appropriato, Furst produce un Burgstadter Centgrafenberg Riesling Eiswein altamente investibile. L'annata 2002 è stata l'ultima uscita, che ha ottenuto un punteggio di 96 punti da Robert Parker's Wine Advocate ed è quasi (se non del tutto) impossibile da trovare.</li>
                            <li>Nel 2018, Sebastian Fürst è stato nominato Falstaff Winemaker of the Year, Germania.</li>
                        </ul>
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Rudolf Furst</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Für Anhänger des internationalen Weininvestitionsmarktes ist die Rolle des Pinot Noir in Deutschland wichtig
                        interessant. Während die Preise für burgundische Pinots in die Höhe schießen, haben Käufer auf dem Zweitmarkt begonnen, sie auszugießen
                        Netze weiter entfernt für vergleichbare Qualität zu einem weitaus günstigeren Preis. Und Deutschland heißt Sie willkommen
                        Alternative; Hervorragende Qualität, langes Lagerpotenzial und eine Marketing-Exportstrategie, die bettelarm ist
                        Ich glaube, dass sich bestimmte Produzenten wie Rudolf Fürst von der Masse abheben. Als
                        Weinguru Jancis Robinson sagte 2018: „Der deutsche Pinot Noir gehört jetzt in die Gesellschaft der Großen.“
                        Pinot Noirs auf der ganzen Welt …“
                    </div>

                    <div class="howto-title2">Paul und Sebastian sind ein tolles Vater-Sohn-Team</div>
                    <div class="howto-text">
                        Die Fursts sind seit über 400 Jahren eine Winzerfamilie, in der sie geboren und aufgewachsen sind
                        nach Süden ausgerichtete Felder. Das Anwesen ist eine Familie leidenschaftlicher Traditionalisten und wird von Paul und seinen Freunden geführt
                        Sohn Sebastian (die 2. und 3. Generation von Fursts soll an der Spitze stehen). Die 15 Hektar Eisen
                        Das reiche Terroir wird wie immer bewirtschaftet: schonende Methoden, geringe Erträge, sorgfältig
                        Schirmmanagement und inszenierte Auswahlpässe, unterstrichen durch großes Engagement. Das ist dann
                        Anschließend folgt eine lange, sanfte Lagerung in Eichenfässern (zwischen 12 und 20 Monaten), um Ergebnisse zu erzielen, die überzeugend sind
                        großartig und hochgelobt. Ob wir nun über ihre Pinot Noirs (Spätburgunder) sprechen oder
                        trockene Rieslinge, sowohl die Rot- als auch die Weißweine dieses Weinguts sind magisch.
                    </div>

                    <div class="howto-title2">2014 war der „Wein des Jahres“</div>
                    <div class="howto-text">
                        Rudolf Fürst hat einen langen Weg zurückgelegt, um Robert Parker das Gegenteil zu beweisen. Parker wird bekanntlich zitiert als:
                        „Der deutsche Pinot Noir ist ein grotesker und grässlicher Wein, der wie ein mangelhafter Wein schmeckt.“
                        süßer, verblasster, verdünnter roter Burgunder von einem inkompetenten Produzenten.“ Seine Kommentare waren vielleicht
                        teilweise verantwortlich für das mangelnde Interesse oder die mangelnde Verfügbarkeit von Rudolf-Furst-Weinen in den USA,
                        wohingegen der britische Mega-Fan Jancis Robinson („Rudolf Fürst“ ein anerkannter Pinot Noir-Gelehrter ist
                        Deutschland.") könnte durchaus einer der Gründe sein, warum die Weine in Großbritannien so beliebt sind. Trotzdem
                        Aufgrund der konstant hohen Bewertungen (vor allem von Jancis) bleiben die Weine preisgünstig; mit
                        ein Anstieg von 23 % in etwa fünf Jahren von 2014 bis 2019. Heute müssen Sie in Europa mit einem Preis von etwa 100 € rechnen
                        für den Jahrgang 2014 eine Gesamtpunktzahl von 92 Punkten und Deutschlands „Rotwein des Jahres“.
                    </div>

                    <div class="howto-title2">Bemerkenswerte Fakten und Jahrgänge</div>
                    <div class="howto-text">
                        <ul>
                            <li>US-Nachrichtenquelle Bloomberg in ihrem Artikel „Deutscher Pinot Noir ist die trendige Alternative zu teuer.“
                                Der Artikel „Burgund“ beschreibt Fursts „... schwer zu findende, teure Pinotweine aus einzelnen Weinbergen
                                [gehören] zu den besten in Deutschland.“
                            </li>
                            <li>Gegebenenfalls produziert Furst einen hoch investierbaren Burgstadter Centgrafenberg Riesling Eiswein. Der Jahrgang 2002 war die neueste Veröffentlichung, die von Robert Parker’s Wine Advocate mit 96 Punkten bewertet wurde und nahezu (wenn nicht sogar völlig) unmöglich zu finden ist.</li>
                            <li>Im Jahr 2018 wurde Sebastian Fürst zum Falstaff-Winzer des Jahres in Deutschland gekürt.</li>
                        </ul>
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Rudolf Furst</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Pour les adeptes du marché international des vins d'investissement, le rôle du Pinot Noir en Allemagne est
                        intéressant. Alors que les prix des pinots bourguignons s'envolent, les acheteurs du second marché ont commencé à jeter leur
                        filets plus loin pour une qualité comparable à un prix bien inférieur. Et l'Allemagne offre un accueil
                        alternative; une superbe qualité, un long potentiel de garde et une stratégie marketing export qui mendie
                        croyance, certains producteurs comme Rudolf Furst, se démarquent de la masse. Comme
                        Le gourou du vin Jancis Robinson a déclaré en 2018 : « Le pinot noir allemand appartient désormais à la compagnie des grands
                        Les pinots noirs dans le monde… ».
                    </div>

                    <div class="howto-title2">Paul et Sébastien forment une excellente équipe père-fils</div>
                    <div class="howto-text">
                        Famille viticole depuis plus de 400 ans, les Furst sont nés et ont grandi dans leur
                        champs exposés au sud. Famille de traditionalistes passionnés, le domaine est dirigé par Paul et ses
                        fils Sebastian (les 2e et 3e générations de Fursts à la barre). Les 15 hectares de fer
                        un terroir riche est cultivé comme il l'a toujours été : méthodes à faible impact, rendements réduits, minutie
                        gestion de la canopée et passages de sélection par étapes, soulignés par un immense dévouement. C'est alors
                        suivi d'un élevage long et doux en fûts de chêne (entre 12 et 20 mois), pour des résultats
                        superbe et très apprécié. Qu'il s'agisse de leurs pinots noirs (Spätburgunder) ou
                        Rieslings secs, tant les rouges que les blancs produits par ce domaine sont magiques.
                    </div>

                    <div class="howto-title2">2014 était le "Vin de l'Année"</div>
                    <div class="howto-text">
                        Rudolf Furst a parcouru un long chemin pour prouver que Robert Parker avait tort. Parker est célèbre comme
                        disant "Le pinot noir allemand est un vin grotesque et horrible qui a le goût d'un vin défectueux,
                        Bourgogne rouge doux, fané et dilué d'un producteur incompétent. Ses commentaires ont peut-être été
                        en partie responsable du manque d'intérêt ou de disponibilité des vins Rudolf Furst aux États-Unis,
                        tandis que le méga-fan britannique Jancis Robinson ("Rudolf Fürst est un sage reconnu du pinot noir dans
                        Allemagne.") pourrait bien être l'une des raisons pour lesquelles les vins sont extrêmement populaires en Grande-Bretagne. Malgré
                        leurs notes toujours élevées (notamment chez Jancis), les vins restent à des prix raisonnables ; avec
                        une augmentation de 23 % en environ cinq ans entre 2014 et 2019. Attendez-vous aujourd'hui à payer environ 100 € en Europe
                        pour un millésime 2014, score cumulé de 92 points et "vin rouge de l'année" en Allemagne.
                    </div>

                    <div class="howto-title2">Faits marquants et millésimes</div>
                    <div class="howto-text">
                        <ul>
                            <li>La source d'information américaine Bloomberg, dans son article intitulé "German Pinot Noir Is the Buzzy Alternative to Pricey
                                L'article de la Bourgogne » décrit les « ... pinots de vignoble uniques difficiles à trouver et chers de Furst
                                [sont] parmi les meilleurs d'Allemagne.
                            </li>
                            <li>Le cas échéant, Furst produit un Burgstadter Centgrafenberg Riesling Eiswein hautement investissable. Le millésime 2002 était la dernière version, qui a obtenu un score de 96 points au Robert Parker's Wine Advocate et est presque (sinon entièrement) impossible à trouver.</li>
                            <li>En 2018, Sebastian Fürst a été nommé Falstaff Winemaker of the Year, Allemagne.</li>
                        </ul>
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Rudolf Furst</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        For followers of the international wines investing market, the role of Pinot Noir in Germany is
                        interesting. As prices soar for Burgundian Pinots, second-market buyers have begun to cast their
                        nets further afield for comparable quality at a far lower price. And Germany offers a welcome
                        alternative; superb quality, long ageing potential and a marketing export strategy that beggars
                        belief, certain producers such as Rudolf Furst, are setting themselves apart from the crowd. As
                        Wine guru Jancis Robinson said in 2018: “German Pinot Noir now belongs in the company of great
                        Pinot Noirs around the world...”.
                    </div>

                    <div class="howto-title2">Paul and Sebastian make a great father-son team</div>
                    <div class="howto-text">
                        A winemaking family for over 400 years, the Fursts were born and brought up in their
                        south-facing fields. A family of passionate traditionalists, the estate is run by Paul and his
                        son Sebastian (the 2nd and 3rd generations of Fursts to be at the helm). The 15-hectares of iron
                        rich terroir is farmed as it always has been: low-impact methods, reduced yields, meticulous
                        canopy management and staged selection passes, underscored by immense dedication. This is then
                        followed by long, gentle, elevage in oak barrels (between 12-20 months), for results which are
                        superb and highly acclaimed. Whether we are talking about their Pinot Noirs (Spätburgunder) or
                        dry Rieslings, both the red and whites produced by this estate are magical.
                    </div>

                    <div class="howto-title2">2014 was the “Wine of the Year”</div>
                    <div class="howto-text">
                        Rudolf Furst has gone a long way to prove Robert Parker wrong. Parker is famously quoted as
                        saying “German Pinot Noir is a grotesque and ghastly wine that tastes akin to a defective,
                        sweet, faded, diluted red Burgundy from an incompetent producer.” His comments have perhaps been
                        in part responsible for the lack of interest or availability of Rudolf Furst wines in the US,
                        whereas British mega-fan Jancis Robinson ("Rudolf Fürst is an acknowledged Pinot Noir sage in
                        Germany.") might well be one of the reasons why the wines are hugely popular in Britain. Despite
                        their consistently high ratings (notably from Jancis), the wines remain reasonably priced; with
                        a 23% rise in approximately five years from 2014-2019. Today expect to pay around €100 in Europe
                        for a 2014 vintage, 92 points aggregate score and Germany’s “red wine of the year”.
                    </div>

                    <div class="howto-title2">Notable facts and vintages</div>
                    <div class="howto-text">
                        <ul>
                            <li>US news source Bloomberg, in their “German Pinot Noir Is the Buzzy Alternative to Pricey
                                Burgundy” article describes Furst’s “...hard-to-find, expensive single vineyard pinots
                                [are] among the finest in Germany.”
                            </li>
                            <li>When appropriate, Furst produces a highly investable Burgstadter Centgrafenberg Riesling Eiswein. The 2002 vintage was the latest release, which earned a Robert Parker’s Wine Advocate score of 96 points and is near (if not entirely) impossible to find.</li>
                            <li>In 2018, Sebastian Fürst was named Falstaff Winemaker of the Year, Germany.</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "RudolfFurst",
    data() {
        return {
            select: {report: 'Rudolf Furst', src: '/wine-guide/germany/franken/rudolf-furst'},
            items: [
                {report: 'Rudolf Furst', src: '/wine-guide/germany/franken/rudolf-furst'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    },
    head: {
        title: 'Rudolf Furst | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the quality and diversity of Rudolf Fürst\'s wines, made in the heart of the Franken wine region in Germany. Experience the unique terroir of this area through the exceptional taste and character of Rudolf Fürst\'s wines.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
